import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Drawer } from '@mui/material'
import useStyles from './mainNavigationStyles'
import clsx from 'clsx'
import ListMainNavigation from './ListMainNavigation'
import MainNavigationToolbar from './MainNavigationToolbar'
import { useMediaXsDown } from '../../hooks/useMediaXsDown'

const MainNavigation = ({ navigationItems, productMeta, isOpen = false, onClickClose }) => {
  const isXsDown = useMediaXsDown()
  const { drawer, drawerOpen, drawerPaper, drawerPusher } = useStyles()

  const drawerProps = useMemo(() => {
    if (isXsDown) {
      return {
        open: isOpen,
        onClose: onClickClose,
        className: drawer,
      }
    }
    return {
      variant: 'permanent',
      className: clsx(drawer, [isOpen && drawerOpen]),
    }
  }, [drawer, drawerOpen, onClickClose, isXsDown, isOpen])

  return (
    <Drawer anchor="left" classes={{ paper: drawerPaper }} data-analytics="mainNavigation" {...drawerProps}>
      {isXsDown ? <MainNavigationToolbar /> : <div className={drawerPusher} />}
      <ListMainNavigation navigationItems={navigationItems} productMeta={productMeta} isOpen={isOpen} />
    </Drawer>
  )
}

MainNavigation.propTypes = {
  navigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      itemText: PropTypes.string.isRequired,
      itemIcon: PropTypes.node.isRequired,
      isSelected: PropTypes.bool,
      handleClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  productMeta: PropTypes.shape({
    productName: PropTypes.string.isRequired,
    productTooltip: PropTypes.string.isRequired,
    productIcon: PropTypes.node.isRequired,
    handleClick: PropTypes.func,
  }),
  isOpen: PropTypes.bool,
  onClickClose: PropTypes.func.isRequired,
}

export default MainNavigation
